// extracted by mini-css-extract-plugin
export var center = "_1j-2";
export var clickableRow = "_1j-5";
export var expandedRow = "_1j-7";
export var hoverable = "_1j-4";
export var left = "_1j-1";
export var right = "_1j-3";
export var row = "_1j-0";
export var selectedRow = "_1j-6";
export var summaryRow = "_1j-8";